import { formatPragueDateTime } from "./dateUtils";
/** Fits "DD.MM.YYYY HH:mm" plus the sort indicator. */
export var DATE_TIME_COLUMN_WIDTH = 150;
/**
 * The "Datum založení" and "Datum poslední aktualizace" columns of a search list. The column keys
 * are the backend sort fields, so header clicks sort the whole result set server side.
 *
 * @param formatMessage - react-intl message formatter.
 * @param messagePrefix - the list's column translation prefix, e.g. "ui-br-agency.title.table.columns".
 * @returns the two column definitions, created first.
 */
export var buildDateAuditColumns = function (formatMessage, messagePrefix) {
    return ["dateCreated", "dateUpdated"].map(function (field) { return ({
        name: formatMessage({ id: "".concat(messagePrefix, ".").concat(field) }),
        key: field,
        sortable: true,
        width: DATE_TIME_COLUMN_WIDTH,
        cellRenderer: function (item) { return formatPragueDateTime(item[field]); },
    }); });
};
